import CashbackRatesForm from './CashbackRatesForm';

export default CashbackRatesForm;
